import { render, staticRenderFns } from "./AccessMoreStrategiesSeeMoreModerateDialog.vue?vue&type=template&id=a4766c40&scoped=true&"
import script from "./AccessMoreStrategiesSeeMoreModerateDialog.vue?vue&type=script&lang=ts&"
export * from "./AccessMoreStrategiesSeeMoreModerateDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AccessMoreStrategiesSeeMoreModerateDialog.vue?vue&type=style&index=0&id=a4766c40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4766c40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDialog,VIcon})
